import { Components } from '@mui/material/styles'

import { fontSizes } from './typography'
import palette from './palette'
import { radii } from './shapings'

const components: Components = {
  MuiPaper: {
    styleOverrides: {
      root: {
        '.MuiCalendarPicker-root .Mui-disabled': {
          color: 'rgb(126, 131, 176, 0.5) !important',
        },
      },
    },
  },
  MuiTooltip: {
    defaultProps: {
      arrow: true,
      placement: 'top' as any,
      enterDelay: 150,
      leaveDelay: 100,
    },
    styleOverrides: {
      arrow: {
        color: '#1F2128',
      },
      tooltip: {
        backgroundColor: '#1F2128',
      },
      tooltipPlacementTop: {
        marginBottom: '1em',
      },
    },
  },
  MuiBreadcrumbs: {
    defaultProps: { separator: '|' },
    styleOverrides: {
      root: {
        fontSize: fontSizes.extraSmall,
        fontWeight: 500,
        color: 'inherit',
        textTransform: 'uppercase' as any,
      },
      separator: {
        color: palette.text.secondary,
      },
      li: {},
    },
  },
  MuiTextField: {
    defaultProps: { variant: 'outlined' as any, size: 'medium' as any },
    styleOverrides: {},
  },
  MuiCheckbox: {
    defaultProps: { color: 'primary' as any },
    styleOverrides: {},
  },
  MuiButton: {
    defaultProps: {
      color: 'primary' as any,
      variant: 'contained' as any,
    },
    styleOverrides: {
      root: {
        fontSize: fontSizes.default,
        borderRadius: radii.default,
        fontWeight: 500,
        textTransform: 'none' as any,
        lineHeight: 1.25,
      },
      contained: {
        boxShadow: 'none',
      },
      sizeMedium: {
        minHeight: 40,
      },
    },
  },
  MuiSkeleton: {
    defaultProps: { animation: 'wave' as any },
    styleOverrides: {},
  },
  MuiAlert: {
    styleOverrides: {
      standardError: {
        color: palette.error.dark,
        '& $icon': {
          color: palette.error.dark,
        },
      },
      root: {
        lineHeight: 1.2,
        fontSize: fontSizes.default,
        alignItems: 'center',
      },
      message: {
        padding: '0.25em 0',
      },
      icon: {
        padding: '0',
      },
    },
  },

  MuiMenuItem: {
    styleOverrides: {
      root: {
        lineHeight: 1.25,
        fontSize: fontSizes.small,
        minHeight: 36,
      },
    },
  },
  MuiListItemIcon: {
    styleOverrides: {
      root: {
        minWidth: 'auto',
        marginRight: 10,
      },
    },
  },
  MuiSvgIcon: {
    defaultProps: {
      fontSize: 'inherit',
    },
    styleOverrides: {
      fontSizeInherit: {
        fontSize: '1.4em',
      },
      fontSizeSmall: {
        fontSize: '1.25rem',
      },
    },
  },
  MuiIconButton: {
    defaultProps: {
      size: 'medium',
      color: 'inherit',
    },
    styleOverrides: {
      sizeSmall: {
        fontSize: '1.1rem',
      },
      sizeMedium: {
        fontSize: '1.2rem',
      },
      sizeLarge: {
        fontSize: '1.3rem',
      },
    },
  },

  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        background: palette.bgLight,
        input: {
          color: '#fffff',
        },
        '& fieldset': {
          border: '1px solid #8D0D4A',
        },
        '&:hover fieldset': {
          border: '1px solid #8D0D4A',
        },
        '.MuiFormLabel-root': {
          color: '#8D0D4A',
        },
      },
      sizeSmall: {
        borderRadius: radii.default,
      },
      adornedEnd: {
        paddingRight: 0,
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        // textTransform: 'none' as any,
      },
      textColorPrimary: {
        '&.Mui-selected': {
          color: palette.text.primary,
        },
      },
    },
  },

  MuiFormHelperText: {
    styleOverrides: {
      root: {
        margin: '0.5rem 0 0',
        lineHeight: 1.2,
        fontSize: fontSizes.extraSmall,
      },
    },
  },

  MuiTableCell: {
    styleOverrides: {
      head: {
        fontSize: fontSizes.small,
        color: palette.text.secondary,
        height: 44,
        whiteSpace: 'nowrap',
      },
      body: {
        height: 56,
        fontSize: fontSizes.small,
        '@media (max-width: 768px)': {
          fontSize: fontSizes.extraSmall,
        },
      },
      root: {
        borderColor: palette.border,
        padding: '0.5em',
        lineHeight: 1.2,
        '&:first-child': {
          paddingLeft: '1rem',
        },
        '&:last-child': {
          paddingRight: '1rem',
          width: '1%',
        },
      },
    },
  },
}

export default components
